module.exports = __webpack_public_path__ + "static/media/permanent-tsb-efficio.426b4b56.png";